import React, {useEffect, useState, useRef} from "react";
import { Link, useLocation, useParams  } from "react-router-dom";
import "./AppStatusElement.css"
import "./Home.css"
import "./SeeallButton.css"
import SocialIconsGroup from "./SocialIconsGroup";
import { FiDownload } from "react-icons/fi";
import { trackEvent } from "./UtilsFunction";

export function AppStatusElement({ onClose, imageTag, onStartExplore }) {

  
 const appInfoRef = useRef()
 const location = useLocation()
 const exploreNextPath = location.pathname.includes("explore-next")
//  const prettyTag =imageTag?.charAt(0).toUpperCase() + imageTag?.slice(1);
 const prettyTag = imageTag
  const [hidden, setHidden] = useState(false);
  const experimentV1 = false
  const showExploreButton = false
    // const userAgent = navigator?.userAgent.toLowerCase();
    const userAgent = typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase() : "";
const isFacebookInApp = userAgent.includes("fban") ||  userAgent.includes("fbav");
const isInstagramInApp = userAgent.includes("instagram");
const isMetaInApp = isFacebookInApp || isInstagramInApp;
  
    const hideDiscoverlyNote = () => {
  localStorage.setItem("hideDiscoveryNote", "true");
   setHidden(true);
    if (onClose) {
      onClose();
    }
    
};
  useEffect(() => {
    const isHidden = localStorage.getItem("hideDiscoveryNote") === "true";
    if (isHidden) setHidden(true);
  }, []);
    if (hidden) return null;
    
 

    

  return (
    <div className={`d-flex justify-content-between align-items-center container  explore-soft-text app_status_item mt-ps90 ${exploreNextPath ? 'border_black' : ''}`} ref={appInfoRef}>
    {/* brand_button_text */}
      <span className=" top_status_text_message">
        {/* Find aesthetic images. Get captions & hashtags. Post instantly. */}
        {/* Find aesthetic post ideas — images, captions & hashtags in one place. */}
        {/* {(exploreNextPath) ? `BrowseNext shows visually similar images. Tap any photo to continue exploring.` : ` Find aesthetic post ideas — images, captions & hashtags in one place.`} */}
        {/* {(exploreNextPath) ? `Tap a photo to explore more ${prettyTag || "similar"} 🔍` : ` Find aesthetic post ideas — images, captions & hashtags in one place.`} */}
        {/* Ready-to-use visuals for posts, status, stories & inspiration */}

          {/* {(exploreNextPath) ? `Tap any image to explore more like this instantly.` : ` Ready-to-use visuals for posts, status, stories & inspiration`} */}
          {/* {(exploreNextPath) ? `Tap any image → see similar images instantly` : ` Ready-to-use visuals for posts, status, stories & inspiration`} */}
          {/* {(exploreNextPath) ? `Create your next post in 1 tap` : ` Ready-to-use visuals for posts, status, stories & inspiration`} */}


          {/* {(exploreNextPath) ? `Tap first image to get your next post` : ` Ready-to-use visuals for posts, status, stories & inspiration`} */}
          {/* {(exploreNextPath) ? `Tap image to get your next post` : ` Ready-to-use visuals for posts, status, stories & inspiration`} */}
          {(exploreNextPath) ? (
            <>
            <div className="d-flex align-items-center gap-1">            
             {/* Tap image to copy caption for <SocialIconsGroup />  instantly  */}
             {/* Tap image to get posts, status, stories & more for <SocialIconsGroup />  instantly  */}
             {/* Your post is ready — copy & post on <SocialIconsGroup /> */}

{(experimentV1 || isMetaInApp) ? (<>
{/*Create your daily social media posts in seconds */}

{/* Ready-to-use posts for Instrgram   */}
Get images, captions & hashtags in one place.



</>): (<>

             {/* Your caption is waiting ✨ — Tap to unlock  */}
             {/* Discover images you can use anywhere  */}
             {/* Ready-to-use posts for social media <SocialIconsGroup /> */}
             {/* You might want to post this 👇 <SocialIconsGroup /> */}

             {/* ✨ No signup. Instant results. */}
             {/* Get ready-to-post content in 1 tap */}
             {/* Find daily-use images without searching or thinking. */}
             {/* Click any image to discover more similar inspiration. */}
             {/* Click on any image to get more similar images. Free to download and use anywhere. */}

             {/* Explore just one image. Come back anytime to continue where you left off. */}
           {/* Explore just one image. Next time you visit, it'll be waiting for you on your home page. */}
           {/* Don't start from scratch every time. Click any image once, and continue from your home page on your next visit. */}
           {/* Don't start from scratch every time. Pick up where you left off on <Link to="/" className="home_link"
            onClick={() =>
    trackEvent("explore_home_link_clicked", {
      
      current_path: window.location.pathname,      
      destination: "/",
      source: "explore_banner",
    })
  }
           >
    Home
  </Link> page. */}

  {/* Free images ready to use anywhere */}
  
  {/* Free high-quality images ready to use anywhere */}

  Find the right image? Use it for your next project


</>)}
             

             </div>
            </>) : (<>
          {/* <div className="home_app_text d-flex align-items-center"> */}
            {/* Explore free images for YouTube thumbnails, social posts and more. */}
            {/* </div> */}
            {/* Get Images with Matched Captions for Creators */}
            {/* Discover emotional images and find captions for your next post. */}
            {/* Discover images that inspire you then find captions that image for your next post. */}
            {/* Find Images. Get Caption Ideas. Create Your Stronger Next Post. */}
           {/* Find Images and Captions in one place for your Next Post. */}
           Find the perfect image and caption in one place for your Next Post.
            
            </>) }
      </span>




<div className="container_explorenext_start">

{exploreNextPath && !isMetaInApp && (<>
  <ExploreStartButton onStartExplore={onStartExplore} prettyTag={prettyTag} experimentV1 />
</>)}


      <i
        className="fa-solid fa-xmark explore_purposetext_close home_status_close_button"
        onClick={hideDiscoverlyNote}
      ></i>
</div>

    </div>
  );
}

// BrowseNext shows visually similar images. Tap any photo to continue exploring.


function ExploreStartButton(props){

  const buttonRef = useRef()

  function sendClickFeed(event , element){    
    let shareButton = event.currentTarget;
    console.log("this", element)
    // console.log("document.title in home", featuredStoredImage)
    if(shareButton){
      buttonRef.current.style.backgroundColor = "#000000b8";
      // shareButton.firstElementChild.style.color = "white";
      shareButton.style.transition = "all 0.05s linear";
      shareButton.style.transform = "scale(0.9)";
  

      console.log("yes click")
      // shareButton.firstElementChild.style.backgroundColor = "white";
    }
    
  }
  function startExplore(){
props?.onStartExplore()

  }
  function removeClickFeed(event){    
    let shareButton = event?.currentTarget;

    if(shareButton){
      buttonRef.current.style.backgroundColor = "black";
      shareButton.style.transform = "scale(1)";
          
      // shareButton.firstElementChild.style.color = "";
      // shareImage(imageUrl)
          // showBlog();
          // shareButton.style.backgroundColor = "";
      
    }
    
  }
  function orignalElement(event){
    let shareButton = event?.currentTarget;

    if(shareButton){
      buttonRef.current.style.backgroundColor = "black";
      shareButton.style.transform = "scale(1)";
      
      // shareButton.firstElementChild.style.color = "";         
    }    
  }
 

  function getButtonText(imageTag) {
  // Step 1: Safe fallback (never undefined/null)
  const safeTag = (imageTag || "").toString().toLowerCase();

  // Step 2: Check intent
  if (safeTag.includes("background")) {
    return "Get Background";
  }

  if (safeTag.includes("wallpaper")) {
    return "Get Wallpaper";
  }

  // Step 3: Default fallback
  return "Start exploring";
}


  return(
     <Link class="explorenext_start_button"
              
             
              //  to={(props.forWhich === "personalized" || props.forWhich === "lastExplored") ? `/explore-next/photo/${encodeURIComponent(props.categoryName)}` : "/explore"}
               draggable={false}
                ref={buttonRef}  
                 onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
               onTouchStart={(e) => sendClickFeed(e)}
      onTouchEnd={(e) => removeClickFeed(e)}
      onTouchCancel={(e) => orignalElement(e)}
      onClick={(e)=>{
        startExplore()
      }}
              
              >
              {/* {props.forWhich === "personalized" ? <ButtonText /> : "See all"} <i className="fa-solid fa-angle-right home_seeall_icon"></i> */}

              {/* <span>Start exploring</span>  */}
              {/* <span>Explore first image</span>  */}
              {/* <p className="btn_text">Create Post</p>  */}
              
              {/* <p className="btn_text">Get Caption</p>  */}
              {/* <p className="btn_text">Tap on image</p>  */}
              {/* <p className="btn_text">Try it</p>  */}

              {/* <p className="btn_text">Copy Caption <i className="fa-solid fa-angle-right home_seeall_icon"></i></p>  */}
              {/* <p className="btn_text">Get Post <i className="fa-solid fa-angle-right home_seeall_icon"></i></p>  */}
              <p className="btn_text">

              {props.experimentV1 ?(<>

              {/* Download Post <FiDownload className="home_seeall_icon" /> */}
              {/* Download Post <FiDownload className="home_seeall_icon" /> */}

              {/* View Post  <i className="fa-solid fa-angle-right home_seeall_icon"></i> */}
             {getButtonText(props.prettyTag)}  <i className="fa-solid fa-angle-right home_seeall_icon"></i>

              </>) : (<>

              {/* Get Caption <i className="fa-solid fa-angle-right home_seeall_icon"></i> */}

              {/* Download Post <FiDownload className="home_seeall_icon" /> */}
              {/* View Post <i className="fa-solid fa-arrow-right home_seeall_icon"></i> */}

              </>)
              } 
              </p> 
              
              
    
              </Link>
  )
}

// Get ready-to-use image for instrgram with caption and hashtags